import { useApolloClient } from "@apollo/client";
import { ModalOpenButton } from "@msys/ui";
import { useUserData } from "../../auth/useUserData.js";
import { ConfirmModal } from "../../commons/modals/ConfirmModal.js";
import { useReactivateMembershipMutation } from "./ReactivateUserButton.generated.js";

interface Props {
  userId: string;
  children: React.ReactElement;
  refetchQueries?: string[];
}

export const ReactivateUserButton = ({
  userId,
  refetchQueries,
  children,
}: Props) => {
  const viewer = useUserData().currentUser!;

  const client = useApolloClient();
  const [reactivate, { loading: isLoading }] = useReactivateMembershipMutation({
    client,
    refetchQueries,
    awaitRefetchQueries: true,
  });

  return (
    <ModalOpenButton
      Modal={ConfirmModal}
      modalProps={{
        handleConfirm: () => {
          reactivate({
            variables: {
              organisationId: viewer.organisation.id,
              userId,
            },
          });
        },
      }}
    >
      {children}
    </ModalOpenButton>
  );
};
